import React, {Component} from 'react';
import {BASE_URL, META_SCREENS} from 'js/constants';
import {PageLinkButton} from 'js/components/button';
import styles from 'css/screens/result.css';
import {AppStore} from 'js/stores'; // singleton stores
import Advice from './advice';
import Score from './score';

/**
 * Result screen
 */
export default class Result extends Component {
  /**
   * constructor
   */
  constructor() {
    super();
  }

  /**
   * did mount
   */
  componentDidMount() {
    AppStore.pageView(META_SCREENS.result);
  }

  /**
   * will unmount
   */
  componentWillUnmount() {
    AppStore.pageLoading();
  }

  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    let nextPage = null;
    switch (AppStore.selectAppType) {
    case 'web':
      nextPage = 'registration';
      break;
    case 'visit':
      // 訪問版の場合、メール送信は不要
      nextPage = 'phaseresult';
      AppStore.updateStep('regist', true);
      break;
    }

    return (
      <section>
        <div className={`${styles.block} ${styles.title}`}>
          <h1>診断結果</h1>
          <div>御社の市場創造PR力は以下の通りです。</div>
        </div>
        <Score />
        <Advice />
        <div className={`${styles.block} ${styles.button}`}>
          <PageLinkButton to={`${BASE_URL}/${nextPage}`}>
            さらに市場創造フェーズを見る
          </PageLinkButton>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/screens/result/index.js